import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import Reveal from "@/marketing/Reveal";
import PricingCards from "@/marketing/PricingCards";
import ComparisonTable from "@/marketing/ComparisonTable";
import { useI18n } from "@/i18n/I18nContext";

export default function Pricing() {
  const { t } = useI18n();
  return (
    <div>
      <section className="pt-36 sm:pt-44 pb-12 px-5 sm:px-8 relative overflow-hidden">
        <div className="absolute top-[-10%] right-[5%] h-[400px] w-[400px] rounded-full bg-[#D4AF37]/10 blur-[120px] -z-10" />
        <div className="max-w-3xl mx-auto text-center">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#B86B5A] mb-4">{t.pricing.overline}</p>
            <h1 className="font-display text-5xl sm:text-6xl font-extrabold tracking-tighter text-[#0A0A0A] leading-none">
              {t.pricing.pageTitle1} <span className="font-serif-lux italic font-medium text-[#B86B5A]">{t.pricing.pageTitle2}</span>
            </h1>
            <p className="mt-6 text-lg text-[#2C3E35]/75">{t.pricing.pageSubtitle}</p>
          </Reveal>
        </div>
      </section>

      <section className="px-5 sm:px-8 pb-16">
        <div className="max-w-7xl mx-auto">
          <Reveal><PricingCards /></Reveal>
          <Reveal delay={0.1} className="mt-6 flex items-center justify-center gap-2 text-sm text-[#2C3E35]/60">
            <ShieldCheck size={16} /> {t.pricing.trialNote}
          </Reveal>
        </div>
      </section>

      <section className="px-5 sm:px-8 py-20 bg-[#F5F2ED]">
        <div className="max-w-4xl mx-auto">
          <Reveal className="text-center mb-10">
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#0A0A0A]">{t.pricing.everythingCompared}</h2>
          </Reveal>
          <Reveal delay={0.1}><ComparisonTable /></Reveal>
        </div>
      </section>

      <section className="px-5 sm:px-8 py-24">
        <Reveal>
          <div className="max-w-5xl mx-auto rounded-[2rem] bg-[#2C3E35] text-[#FDFBF9] p-12 sm:p-16 text-center relative overflow-hidden">
            <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-[#D4AF37]/15 blur-[100px]" />
            <div className="relative">
              <h2 className="font-display text-3xl sm:text-5xl font-extrabold tracking-tight">{t.pricing.readyTitle}</h2>
              <p className="mt-4 text-[#FDFBF9]/75 max-w-lg mx-auto">{t.pricing.readyBody}</p>
              <Link to="/register" data-testid="pricing-cta-trial"
                className="mt-8 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#D4AF37] text-[#2C3E35] font-bold hover:bg-[#e0bd4a] transition-colors">
                {t.pricing.basicCta} <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
